// <s-press-tabs> shows one press quote at a time. Each [data-tab] button reveals the
// [data-panel] with the same index; quotes rotate every 6s unless the visitor prefers
// reduced motion, or is hovering/focusing inside the component.
class PressTabs extends HTMLElement {
  #tabs = [];
  #panels = [];
  #index = 0;
  #timer = 0;

  connectedCallback() {
    this.#tabs = [...this.querySelectorAll("[data-tab]")];
    this.#panels = [...this.querySelectorAll("[data-panel]")];
    if (this.#tabs.length < 2) return;
    this.#tabs.forEach((tab, index) => tab.addEventListener("click", () => this.#show(index)));
    this.addEventListener("pointerenter", this.#stop);
    this.addEventListener("pointerleave", this.#start);
    this.addEventListener("focusin", this.#stop);
    this.addEventListener("focusout", this.#start);
    this.#show(0);
    this.#start();
  }

  disconnectedCallback() {
    this.#stop();
  }

  #start = () => {
    this.#stop();
    if (matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    this.#timer = setInterval(() => this.#show((this.#index + 1) % this.#tabs.length), 6000);
  };

  #stop = () => clearInterval(this.#timer);

  #show(index) {
    this.#index = index;
    this.#tabs.forEach((tab, i) => tab.setAttribute("aria-pressed", String(i === index)));
    this.#panels.forEach((panel, i) => (panel.hidden = i !== index));
  }
}

if (!customElements.get("s-press-tabs")) customElements.define("s-press-tabs", PressTabs);
